import { render, staticRenderFns } from "./tabs_stationery.vue?vue&type=template&id=50618b32"
import script from "./tabs_stationery.vue?vue&type=script&lang=ts"
export * from "./tabs_stationery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports